
































































































































































































	import { Component } from "../../../Infrastructure/CorBase/CoreBase";
    import NotificationSettingDetailBase from "./NotificationSettingDetailBase";

	@Component
    export default class NotificationSettingDetail extends NotificationSettingDetailBase {
		labelWidth = "3";

		//pridani noveho prvku pres modal
        addContentDetail(more: any, idTable: any) {
            this.addContentDetailBase(idTable.id);
		}

		//smazani jedne polozky na radku
        deleteContentDetail(item: any, idTable: any) {
			this.deleteContentDetailBase(item);
		}

		//zrusit zmeny na bloku
        goBackContentDetail(item: any, idTable: any) {
			this.goBackContentDetailBase(item);
        }

		//smazani vsech roli u eventu horni 
        deleteAlll(more: any, idTable: any) {
			this.deleteAllBase(idTable.id);
		}

		modalNameContent() {
            return this.$t('notificationSetting.modalAdd').toString()
		}

		selectedRoleItems(item: any) {
			this.addRoleEventBase(item);
		}

		goBackNotChangeAll() {
			this.goBackNotChangeAllBase();
		}

        saveContentDetail(item: any) {
			this.saveOneEvent();
		}

        changeCheckbox(item: any, item2: any, item3: any, item4: any) {
            this.changeCheckboxBase(item, item2, item3, item4);
		}
				

		mounted() {
			super.mounted();
		};

		created() {
			//TODO prava
			super.initializeRights('COR_NotificationSend_Create', 'COR_NotificationSend_Delete', 'COR_NotificationSend_Read', 'COR_NotificationSend_Update');
            super.setMainDescription('notificationSetting.description', 'notificationSetting.description');
			this.createBase();
		}


	}
